import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

export function useLocations(plan: string, searchText: string) {
  const [debouncedSearchText, setDebouncedSearchText] = useState(searchText);

  // Debounce para evitar muchas llamadas a la API
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, 300); // 300ms de delay

    return () => clearTimeout(timer);
  }, [searchText]);

  // Verificar si el texto de búsqueda es válido (no vacío y no solo espacios en blanco)
  const isValidSearchText = Boolean(debouncedSearchText && debouncedSearchText.trim().length > 0);

  return useQuery({
    queryKey: ['locations', plan, debouncedSearchText],
    queryFn: async () => {
      // No hacer la llamada si no hay plan o texto válido
      if (!plan || !isValidSearchText) {
        return [];
      }

      const res = await fetch(`/api/locations?plan=${encodeURIComponent(plan)}&text=${encodeURIComponent(debouncedSearchText.trim())}`);
      if (!res.ok) throw new Error('Error al obtener las localidades');
      const data = await res.json();
      
      // Normalizar a array
      return Array.isArray(data.LOCALIDAD) ? data.LOCALIDAD : [data.LOCALIDAD];
    },
    enabled: !!plan && isValidSearchText,
    staleTime: 1000 * 60 * 5, // 5 minutos
    gcTime: 1000 * 60 * 10, // 10 minutos
  });
} 